<template>
  <div class="dating-bg">
    <!-- 星星背景 -->
    <div class="stars"></div>
	
    <!-- 简化版樱花容器 -->
       <div class="sakura-container">
         <div v-for="n in 15" :key="n" :class="`sakura sakura-${n}`"></div>
       </div>
	   
    <!-- 心形装饰 -->
    <div class="hearts"></div>
    
    <div class="register-wrapper">
      <div class="login-container">  <!-- 使用与登录页面相同的类名 -->
        <!-- 头部 -->
        <div class="header">
          <i class="back-icon van-icon van-icon-cross" @click="back()"></i>
          <div class="header-right">
            <a class="login-link" @click="toLogin()">{{$t('login.doLogin')}}</a>
          </div>
        </div>
        
        <!-- 内容区域 -->
        <div class="content-wrapper">
          <!-- Logo区域 -->
          <div class="logo-section">
            <div class="logo-circle">
              <img src="../../assets/img/logo2a.png" alt="Logo">
            </div>
            <h1 class="app-title">{{$t('register.register')}}</h1>
          </div>
          
          <!-- 注册表单 -->
          <form class="login-form" @submit.prevent="doRegister">
            <div class="input-group">
              <div class="input-icon">
                <i class="icon-user"></i>
              </div>
              <input 
                type="text" 
                v-model="username" 
                :placeholder="$t('login.usernamePls')"
                class="styled-input"
                autocomplete="username"
              >
            </div>
            
            <div class="input-group">
              <div class="input-icon">
                <i class="icon-lock"></i>
              </div>
              <input 
                :placeholder="$t('login.passwordPls')" 
                v-model="password" 
                :type="passwordType"
                class="styled-input"
                autocomplete="new-password"
              >
              <div class="password-toggle" @click="switchPasswordType">
                <i :class="passwordType === 'password' ? 'icon-eye-closed' : 'icon-eye'"></i>
              </div>
            </div>
            
            <div class="input-group">
              <div class="input-icon">
                <i class="icon-lock"></i>
              </div>
              <input 
                :placeholder="$t('register.repasswordPls')" 
                v-model="repassword" 
                :type="repasswordType"
                class="styled-input"
                autocomplete="new-password"
              >
              <div class="password-toggle" @click="switchrePasswordType">
                <i :class="repasswordType === 'password' ? 'icon-eye-closed' : 'icon-eye'"></i>
              </div>
            </div>
            
            <div class="input-group">
              <div class="input-icon">
                <i class="icon-gift"></i>
              </div>
              <input 
                type="text" 
                v-model="code" 
                :placeholder="$t('register.codePls')"
                class="styled-input"
              >
            </div>
          </form>
          
          <!-- 协议同意 -->
          <div class="agreement-section">
            <div class="agreement-checkbox" @click="checked = !checked">
              <div class="custom-checkbox" :class="{checked: checked}">
                <i class="check-icon">✓</i>
              </div>
              <a class="agreement-link">{{$t('register.xieyi')}}</a>
            </div>
          </div>
          
          <!-- 注册按钮 -->
          <div 
            class="login-btn"
            :class="btnState ? 'active' : ''" 
            @click="doRegister()"
          >
            <span>{{$t('register.register')}}</span>
            <div class="btn-sparkle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      password: this.inputValue,
      passwordType: 'password',
      repassword: this.inputValue,
      repasswordType: 'password'
    };
  },
  computed: {
    btnState() {
      return this.username !== "" && 
             this.password !== "" && 
             this.repassword !== "" && 
             this.code !== "" && 
             this.checked;
    }
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    switchrePasswordType() {
      this.repasswordType = this.repasswordType === 'password' ? 'text' : 'password';
    },
    toLogin() {
      this.$router.push("Login");
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (!this.btnState) return;
      
      if (this.username === "" || this.username === null || this.username === undefined) {
        this.$toast(this.$t('login.usernamePls'));
        return false;
      }
      if (this.password === "" || this.password === null || this.password === undefined) {
        this.$toast(this.$t('login.passwordPls'));
        return false;
      }
      if (this.repassword === "" || this.repassword === null || this.repassword === undefined) {
        this.$toast.fail(this.$t('register.repasswordPls'));
        return false;
      }
      if (this.code === "" || this.code === null || this.code === undefined) {
        this.$toast.fail(this.$t('register.codePls'));
        return false;
      }
      if (!this.checked) {
        this.$toast.fail(this.$t('register.xieyiPls'));
        return false;
      }
      
      this.$http({
        method: 'post',
        data: {
          username: this.username,
          password: this.password,
          repassword: this.repassword,
          code: this.code
        },
        url: 'member_register'
      }).then(res => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem('token', res.data);
          this.$router.push("Mine");
        } else {
          this.$toast.fail(res.msg);
        }
      });
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
  }
};
</script>

<style lang="less" scoped>
// 变量定义 - 使用与登录页面相同的蓝色渐变
@primary-blue: #667eea;
@primary-purple: #764ba2;
@light-blue: #e6eeff;
@white: #ffffff;
@light-gray: #f5f5f5;
@text-dark: #333333;
@text-light: #888888;
@border-color: #e2e8f0;

// 动画定义 - 与登录页面相同
@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  33% { transform: translateY(-15px) rotate(5deg); }
  66% { transform: translateY(-8px) rotate(-3deg); }
}

@keyframes sparkle {
  0%, 100% { opacity: 0; transform: scale(0); }
  50% { opacity: 1; transform: scale(1); }
}

@keyframes twinkle {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.8; }
}

@keyframes bgShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

// 主样式 - 使用与登录页面相同的渐变背景色
.dating-bg {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(-45deg, #3498db, #8e44ad, #3498db, #8e44ad);
  background-size: 400% 400%;
  animation: bgShift 15s ease infinite;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: auto;
  
  // 星星背景
  .stars {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      radial-gradient(2px 2px at 20px 30px, #fff, transparent),
      radial-gradient(2px 2px at 40px 70px, #fff, transparent),
      radial-gradient(1px 1px at 90px 40px, #fff, transparent),
      radial-gradient(1px 1px at 130px 80px, #fff, transparent),
      radial-gradient(2px 2px at 160px 30px, #fff, transparent),
      radial-gradient(2px 2px at 200px 90px, #fff, transparent),
      radial-gradient(1px 1px at 250px 50px, #fff, transparent);
    background-repeat: repeat;
    animation: twinkle 6s ease-in-out infinite;
    z-index: 1;
  }
  
  // 心形装饰
  .hearts {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    
    &::before, &::after, &::first-line {
      content: "";
      position: absolute;
      color: rgba(255, 255, 255, 0.4);
      font-size: 24px;
      animation: float 8s ease-in-out infinite;
    }
    
    &::before {
      top: 15%;
      left: 10%;
      animation-delay: 0s;
    }
    
    &::after {
      top: 20%;
      right: 15%;
      animation-delay: 2s;
      content: "";
    }
    
    &::first-line {
      top: 70%;
      left: 5%;
      animation-delay: 4s;
      content: "";
    }
  }
}

// 注册包装器 - 与登录页面相同
.register-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  min-height: 100vh;
  box-sizing: border-box;
}

// 登录容器 - 使用与登录页面完全相同的样式
.login-container {
  width: 94%;
  max-width: 440px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 25px 28px 30px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 0 80px rgba(102, 126, 234, 0.1);
  z-index: 10;
  position: relative;
  
  // 添加边框光泽效果 - 更新颜色
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 24px;
    padding: 2px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.4), rgba(118, 75, 162, 0.4));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
}

// 头部 - 与登录页面相同
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  .back-icon {
    font-size: 22px;
    color: @text-dark;
    cursor: pointer;
    transition: all 0.3s;
    padding: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.7);
    
    &:hover {
      color: @primary-blue;
      background: rgba(102, 126, 234, 0.1);
      transform: rotate(90deg);
    }
  }
  
  .login-link {
    font-size: 15px;
    color: @primary-blue;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s;
    padding: 10px 18px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15));
    border: 2px solid rgba(102, 126, 234, 0.4);
    border-radius: 20px;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    
    &:hover {
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.25), rgba(118, 75, 162, 0.25));
      border-color: rgba(102, 126, 234, 0.7);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
    }
  }
}

// Logo区域 - 与登录页面相同
.logo-section {
  text-align: center;
  margin-bottom: 25px;
  
  .logo-circle {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: linear-gradient(135deg, @primary-blue, @primary-purple);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 15px;
    box-shadow: 0 8px 25px rgba(118, 75, 162, 0.4);
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: -10px;
      left: -10px;
      right: -10px;
      bottom: -10px;
      background: linear-gradient(135deg, transparent, rgba(255, 255, 255, 0.3), transparent);
      transform: rotate(45deg);
    }
    
    img {
      width: 60%;
      height: auto;
      z-index: 2;
      position: relative;
    }
  }
  
  .app-title {
    font-size: 26px;
    color: @text-dark;
    margin: 0;
    font-weight: 800;
    background: linear-gradient(135deg, @primary-blue, @primary-purple);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

// 表单 - 与登录页面相同
.login-form {
  margin-bottom: 15px;
}

.input-group {
  position: relative;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  
  .input-icon {
    position: absolute;
    left: 20px;
    z-index: 2;
    color: @text-light;
    
    &::before {
      font-size: 20px;
    }
  }
  
  .styled-input {
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 26px;
    background: @light-gray;
    padding: 0 55px;
    font-size: 16px;
    transition: all 0.3s;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
    
    &:focus {
      outline: none;
      background: @white;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3), inset 0 2px 4px rgba(0, 0, 0, 0.05);
      transform: translateY(-2px);
    }
    
    &::placeholder {
      color: #bbb;
    }
  }
  
  .password-toggle {
    position: absolute;
    right: 20px;
    cursor: pointer;
    color: @text-light;
    transition: all 0.3s;
    padding: 8px;
    border-radius: 50%;
    
    &:hover {
      color: @primary-blue;
      background: rgba(102, 126, 234, 0.1);
    }
    
    &::before {
      font-size: 20px;
    }
  }
}

// 图标字体类 - 与登录页面相同
.icon-user::before { content: ""; }
.icon-lock::before { content: ""; }
.icon-eye::before { content: ""; }
.icon-eye-closed::before { content: "‍"; }
.icon-gift::before { content: ""; }

// 协议同意区域
.agreement-section {
  margin-bottom: 20px;
  
  .agreement-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    
    .custom-checkbox {
      width: 18px;
      height: 18px;
      border: 2px solid @border-color;
      border-radius: 4px;
      background: @white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &.checked {
        background: linear-gradient(135deg, @primary-blue, @primary-purple);
        border-color: transparent;
        
        .check-icon {
          opacity: 1;
          transform: scale(1);
          color: @white;
        }
      }
      
      .check-icon {
        font-size: 12px;
        font-weight: bold;
        opacity: 0;
        transform: scale(0);
        transition: all 0.3s ease;
      }
    }
    
    .agreement-link {
      font-size: 14px;
      color: @primary-blue;
      font-weight: 600;
      cursor: pointer;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

// 登录按钮 - 使用与登录页面相同的样式
.login-btn {
  width: 100%;
  height: 52px;
  border-radius: 26px;
  background: linear-gradient(to right, #3498db, #8e44ad);
  display: flex;
  justify-content: center;
  align-items: center;
  color: @white;
  font-size: 17px;
  font-weight: 700;
  cursor: not-allowed;
  margin-bottom: 16px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  
  &.active {
    background: linear-gradient(to right, @primary-blue, @primary-purple);
    cursor: pointer;
    box-shadow: 0 8px 25px rgba(118, 75, 162, 0.5);
    
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 30px rgba(118, 75, 162, 0.6);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 4px 15px rgba(118, 75, 162, 0.4);
    }
    
    .btn-sparkle {
      position: absolute;
      width: 20px;
      height: 20px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      animation: sparkle 2s infinite;
      
      &:nth-child(1) {
        top: 10px;
        left: 35px;
        animation-delay: 0s;
      }
      
      &:nth-child(2) {
        top: 6px;
        right: 45px;
        animation-delay: 0.7s;
      }
    }
  }
}

// 增强版樱花飘落效果
// 简化版樱花飘落效果
.sakura-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 3;
  overflow: hidden;
}

.sakura {
  position: absolute;
  top: -50px;
  font-size: 20px;
  opacity: 0.8;
  animation: sakura-fall linear infinite;
  user-select: none;
  z-index: 3;
}

// 樱花飘落动画
@keyframes sakura-fall {
  0% {
    transform: translateY(-50px) translateX(0px) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.6;
  }
  100% {
    transform: translateY(100vh) translateX(20px) rotate(360deg);
    opacity: 0;
  }
}

// 为每个樱花设置不同的位置和时间
.sakura-1 { left: 5%; animation-duration: 15s; animation-delay: 0s; }
.sakura-2 { left: 15%; animation-duration: 18s; animation-delay: 2s; }
.sakura-3 { left: 25%; animation-duration: 12s; animation-delay: 1s; }
.sakura-4 { left: 35%; animation-duration: 20s; animation-delay: 3s; }
.sakura-5 { left: 45%; animation-duration: 16s; animation-delay: 0.5s; }
.sakura-6 { left: 55%; animation-duration: 14s; animation-delay: 2.5s; }
.sakura-7 { left: 65%; animation-duration: 19s; animation-delay: 1.5s; }
.sakura-8 { left: 75%; animation-duration: 13s; animation-delay: 0.8s; }
.sakura-9 { left: 85%; animation-duration: 17s; animation-delay: 2.2s; }
.sakura-10 { left: 95%; animation-duration: 11s; animation-delay: 1.2s; }
.sakura-11 { left: 10%; animation-duration: 16s; animation-delay: 3.5s; }
.sakura-12 { left: 30%; animation-duration: 14s; animation-delay: 0.3s; }
.sakura-13 { left: 50%; animation-duration: 18s; animation-delay: 2.8s; }
.sakura-14 { left: 70%; animation-duration: 12s; animation-delay: 1.8s; }
.sakura-15 { left: 90%; animation-duration: 15s; animation-delay: 0.7s; }

// 不同的樱花样式
.sakura:nth-child(odd) {
  color: #ffb6c1; // 浅粉色
}

.sakura:nth-child(even) {
  color: #ff69b4; // 深粉色
}

// 响应式适配
@media (max-width: 480px) {
  .sakura {
    font-size: 16px;
  }
}

// 响应式设计 - 与登录页面相同
@media (max-width: 480px) {
  .login-wrapper {
    padding: 40px 0 30px;
    align-items: center;
  }
  
  .login-container {
    width: 92%;
    max-width: none;
    padding: 20px 20px 25px;
    border-radius: 20px;
  }
  
  .header {
    margin-bottom: 18px;
    
    .back-icon {
      font-size: 20px;
      padding: 6px;
    }
    
    .login-link {
      padding: 8px 16px;
      font-size: 14px;
    }
  }
  
  .logo-section {
    margin-bottom: 22px;
    
    .logo-circle {
      width: 85px;
      height: 85px;
      margin-bottom: 12px;
    }
    
    .app-title {
      font-size: 24px;
    }
  }
  
  .input-group {
    margin-bottom: 16px;
    
    .styled-input {
      height: 50px;
      padding: 0 50px;
      font-size: 15px;
    }
    
    .input-icon, .password-toggle {
      &::before {
        font-size: 18px;
      }
    }
  }
  
  .login-btn {
    height: 50px;
    font-size: 16px;
    margin-bottom: 14px;
  }
}

// 平板和桌面端优化
@media (min-width: 768px) {
  .login-wrapper {
    padding: 30px 0;
  }
  
  .login-container {
    max-width: 420px;
    padding: 30px 32px 35px;
  }
  
  .logo-section .logo-circle {
    width: 95px;
    height: 95px;
  }
  
  .app-title {
    font-size: 28px;
  }
}

// 大桌面端优化
@media (min-width: 1200px) {
  .login-wrapper {
    padding: 40px 0;
  }
  
  .login-container {
    max-width: 440px;
    padding: 35px 40px 40px;
  }
}
</style>